// Brand marks for the bulk-import sources. Inlined so the tiles don't depend
// on remote assets, and shared by the import page and the empty-vault state.

export const DriveMark = () => (
  <svg viewBox="0 0 87.3 78" width="30" height="27" aria-hidden>
    <path
      d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z"
      fill="#0066da"
    />
    <path
      d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z"
      fill="#00ac47"
    />
    <path
      d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z"
      fill="#ea4335"
    />
    <path
      d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z"
      fill="#00832d"
    />
    <path
      d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
      fill="#2684fc"
    />
    <path
      d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z"
      fill="#ffba00"
    />
  </svg>
);

export const DropboxMark = () => (
  <svg viewBox="0 0 43 40" width="30" height="28" aria-hidden>
    <path
      d="M12.6 0 0 8.2l8.7 7 12.8-7.9L12.6 0Zm17.8 0-8.9 7.3 12.8 7.9 8.7-7L30.4 0ZM0 22.1l12.6 8.3 8.9-7.4-12.8-7.9L0 22.1Zm43 0-8.7-7-12.8 7.9 8.9 7.4L43 22.1ZM12.7 32l8.8 7.3 8.9-7.3-8.9-7.3-8.8 7.3Z"
      fill="#0061FF"
    />
  </svg>
);

export const IcloudMark = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden>
    <path
      d="M18.4 10.3a4.6 4.6 0 0 0-8.8-1.7 3.5 3.5 0 0 0-4.8 3.2c0 .1 0 .3.1.4A3.3 3.3 0 0 0 5.8 18h12a3.9 3.9 0 0 0 .6-7.7Z"
      fill="#3693F3"
    />
  </svg>
);

export const ComputerMark = () => (
  <svg viewBox="0 0 24 24" width="30" height="30" aria-hidden>
    <rect
      x="3"
      y="5"
      width="18"
      height="12"
      rx="1.6"
      fill="none"
      stroke="#023f42"
      strokeWidth="1.8"
    />
    <path
      d="M8 20h8m-4-3v3"
      stroke="#023f42"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M12 8v5m0 0-2.2-2.2M12 13l2.2-2.2"
      stroke="#e17e37"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
